import { Spinner } from "react-bootstrap";

export const LoadingContainer = () =>
  <div className="centercenter">
    <Spinner animation="border" size="sm" variant="primary" />
  </div>;
